import {Injectable} from '@angular/core';
import {RaintreeResponse} from 'src/app/raintree/interface/raintree-response';
import {TenantResponse} from 'src/app/raintree/interface/tenant-response/tenant-response';
import {
	TenantVerificationTransmissionService
} from 'src/app/raintree/transmission/tenant-verification-transmisssion/tenant-verification-transmission.service';
import {RequestMapperService} from 'src/app/request-mapper.service';
import {CheckTenantEmail} from '../interface/check-tenant-email';
import {TenantVerification} from '../interface/tenant-verification';
import {ToastMessageService} from 'src/app/services/toast-message.service';
import {VerifyToken} from '../interface/verify-token';
import {Subject} from 'rxjs';
import {ResetPassword} from '../interface/reset-password';
import {Router} from '@angular/router';

@Injectable({
	providedIn: 'root'
})
export class VerifyVerificationService {

	constructor(
		private _tenantVerficationRequest: TenantVerificationTransmissionService,
		private _toast: ToastMessageService,
		private _router: Router,
	) { }

	public isUserVerified = false;
	public isUserRegistered = false;
	public isEmailVerificationSuccessful = new Subject<boolean>();

	public tenantStatusStored: TenantVerification = {} as TenantVerification;

	public isVerificationEmailSent:Subject<boolean> = new Subject<boolean>;

	public checkUserStatus(email: string): void {

		let tenantEmail: CheckTenantEmail = {
			email: email
		}

		this._tenantVerficationRequest.verifyTenant(
			RequestMapperService.VERIFY_TENANT,
			tenantEmail,
			() => { },
			() => { },
			(response: RaintreeResponse | TenantResponse) => {
				// console.log(response)
				this.tenantStatusStored = response.entity;
				this.tenantStatusStored.hitApi = true;
				this.isUserVerified = response.entity.emailVerified;
				this.isUserRegistered = response.entity.registered;

			},
			(error: string) => {
				// console.log(error)
			},
			() => {
			}

		)
	}

	public sendEmail(email: string): void {

		let tenantEmail: CheckTenantEmail = {
			email: email
		}

		this._tenantVerficationRequest.sendEmail(
			RequestMapperService.SEND_EMAIL,
			tenantEmail,
			() => { },
			() => { },
			(response: RaintreeResponse | TenantResponse) => {
				// console.log(response)
				this._toast.success('email send successfully.', 'Please check your email and verify.');
			},
			(error: string) => {
				// console.log(error)
			},
			() => {
			}

		)
	}

	public sendPasswordResetEmail(email: string): void {

		let tenantEmil: CheckTenantEmail = {
			email: email.toLowerCase()
		}

		this._tenantVerficationRequest.sendPasswordResetEmail(
			RequestMapperService.SEND_PASSWORD_RESET_EMAIL,
			tenantEmil,
			() => { },
			() => { },
			(response: RaintreeResponse | TenantResponse) => {
				// console.log(response)
				this._toast.success('email send successfully.', 'Please check your email and verify.');
				this.isVerificationEmailSent.next(true)
			},
			(error: string) => {
				// console.log(error)
			},
			() => {
			}

		)
	}

	public verifyEmailToken(token: string): void {

		let tenantEmil: VerifyToken = {
			token: token
		}

		this._tenantVerficationRequest.verifyEmail(
			RequestMapperService.VERIFY_TOKEN,
			tenantEmil,
			() => { },
			() => { },
			(response: RaintreeResponse | TenantResponse) => {
				// console.log(response)
				this._toast.success(response.message, response.message);
				if(response.message!=='token is invalid!'){
					this.isEmailVerificationSuccessful.next(true);
				}
				else{
					this.isEmailVerificationSuccessful.next(false)
				}

			},
			(error: string) => {
				// console.log(error);
				this.isEmailVerificationSuccessful.next(false)
			},
			() => {
			}

		)
	}

	public resetPassword(payload: ResetPassword, demo: boolean = false): void {

		this._tenantVerficationRequest.resetPasswordRequest(
			RequestMapperService.PASSWORD_RESET,
			payload,
			() => { },
			() => { },
			(response: RaintreeResponse | TenantResponse) => {
				// console.log(response)
				this._toast.success(response.message, response.message);
				if(response.success) this._router.navigate([demo? 'demo/auth/login' : 'auth/login']);

			},
			(error: string) => {
				// console.log(error);
				this._toast.success(error, error);
			},
			() => {
			}

		)
	}
}
